import { StateCreator } from 'zustand'
import { RootSlice } from './rootType'

export interface SessionSlice {
  session: {
    isExpired: boolean
    isFeatureEnabled: boolean
    setExpired: (expired: boolean) => void
    setFeatureEnabled: (enabled: boolean) => void
  }
}

export const createSessionSlice: StateCreator<
  RootSlice,
  // Type `never` is used here to follow the instructions on Zustand docs
  // reference: https://github.com/pmndrs/zustand/blob/main/docs/guides/typescript.md#middlewares-and-their-mutators-reference
  // see index.ts for middlewares being used
  [['zustand/devtools', never], ['zustand/immer', never]],
  [],
  SessionSlice
> = (set) => ({
  session: {
    isExpired: false,
    isFeatureEnabled: false,
    setExpired: (expired) => {
      set((state) => {
        state.session.isExpired = expired
      })
    },
    setFeatureEnabled: (enabled) => {
      set((state) => {
        state.session.isFeatureEnabled = enabled
      })
    }
  }
})
